module.exports = __webpack_public_path__ + "img/ydj.6cd96ed6.png";